import React, { useState } from "react";
import FormAlert from "components/forms/FormAlert";
import Form from "react-bootstrap/Form";
import FormField from "components/forms/FormField";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Col from "react-bootstrap/Col";
import { useForm, Controller } from "react-hook-form";
import { useAuth } from "util/auth.js";
import {
  getUploadUrl,
  uploadFileToPresignedUrl,
} from "util/file-upload.js";
import Server from 'util/Server';
import { GoogleApiWrapper } from 'google-maps-react';
import FormAddressField from "components/forms/FormAddressField";
import AppState from "util/AppState";
import { Dictionary } from "util/Dictionary";
import { useRouter } from "next/router";
import { get } from "lodash";


const carMakeArray = [
  "Acura", "Aixam", "Alfa Romeo", "Alpina", "Asia", "Aston Martin", "Audi", 
  "Bentley", "BMW", "Briliance", "Buick", "Cadillac", "Chevrolet", "Chrysler", 
  "Citroen", "Dacia", "Daewoo", "Daihatsu", "Datsun", "Dodge", "DS Automobiles", 
  "Excalibur", "Ferrari", "Fiat", "Ford", "GAZ", "GMC", "Great Wall", "Honda", 
  "Hummer", "Hyundai", "Infiniti", "Isuzu", "Iveco", "Jaguar", "Jeep", "Kia", 
  "Lada", "Lancia", "Land Rover", "Landwind", "Lexus", "Ligier", "Lincoln", 
  "Lotus", "LuAZ", "MAN", "Maserati", "Maybach", "Mazda", "Mercedes-Benz", 
  "Mercury", "MG", "Microcar", "Mini", "Mitsubishi", "Moskvich", "Nissan", 
  "Oldsmobile", "Opel", "Peugeot", "Piaggio", "Pontiac", "Porsche", "Renault", 
  "Rolls-Royce", "Rover", "Saab", "Santana", "Seat", "Seres", "Skoda", "Smart", 
  "SsangYong", "Subaru", "Suzuki", "Tesla", "Think", "Toyota", "Trabant", "Triumph", 
  "UAZ", "Vauxhall", "Volkswagen", "Volvo", "ZAZ" 
];


function AddCarForm(props) {
  const [pending, setPending] = useState(false);
  const [pendingFileUpload, setPendingFileUpload] = useState(false);
  const [fileInputAlert, setfileInputAlert] = useState(null);
  const [formAlert, setFormAlert] = useState(null);

  const { handleSubmit, register, errors, reset, setValue, clearErrors, control, setError } = useForm();
  const { car } = props;
  const auth = useAuth();
  const router = useRouter();

  // Form submit function
  const onSubmit = async (data) => {
    setPending(true);

    if (data.lat.length === 0 || data.lng.length === 0) {
      setError('address', { type: 'manual', message: 'Pasirinkite lokaciją iš sąrašo' });
      setPending(false);
      return;
    }

    data.owner_phone_number = auth.user.phoneNumber;
    let token = auth.user.token;

    data.pickup_location = JSON.stringify({"latitude": data.lat, "longitude": data.lng});
    data.current_location = JSON.stringify({"latitude": data.lat, "longitude": data.lng});
    data.hardware = JSON.stringify({ "type": "no-hardware" }); // default - no-hardware. Add a field later.
    
    if (!car) {
      // pricing will be default for now. Will need to add a separate set of fields later.
      data.pricing = JSON.stringify({ "type": "periods", "periods": [{ "period_from_name": "1 days", "from_total_in_seconds": 86400, "period_unit_in_seconds": 86400, "price": { "per_unit": 1500, "fixed": 0 }, "currency": "EUR" }, { "period_from_name": "3 days", "from_total_in_seconds": 259200, "period_unit_in_seconds": 86400, "price": { "per_unit": 1200, "fixed": 0 }, "currency": "EUR" }] });

      Server().createCarAsync(Server.VEHICLE_URL, data, token)
        .then(result => { 
          console.log("Submit result: "); 
          console.log(result); 
          // Show status to user
          if (result.status.value == true) {
            setFormAlert({
              type: "success",
              message: "Ačiū! Jūsų automobilis pridėtas.",
            });
            // redirect to the Pricing page
            const carId = result.payload.uuid;
            setTimeout(function () {
              props.onSuccessfulCarUpload(carId);
            }, 1500); // wait 1.5 seconds before redirecting

          } else {
            setFormAlert({
              type: "error",
              message: "Įvyko klaida. Bandykite dar kartą arba susisiekite su TryMyCar tiesiogiai: +370 625 13762.",
            });
          }

        });
    } else {
      Server().updateCarAsync(`${Server.VEHICLE_URL}/${car.id}`, data, token)
        .then(result => { 
          console.log("Submit result: "); 
          console.log(result); 
          // Show status to user
          if (result.status.value == true) {
            setFormAlert({
              type: "success",
              message: "Ačiū! Jūsų automobilis išsaugotas.",
            });
            // redirect to the Pricing page
            const carId = result.payload.id;
            setTimeout(function () {
              props.onSuccessfulCarUpload(carId);
            }, 1500); // wait 1.5 seconds before redirecting

          } else {
            setFormAlert({
              type: "error",
              message: "Įvyko klaida. Bandykite dar kartą arba susisiekite su TryMyCar tiesiogiai: +370 625 13762.",
            });
          }
        });
    }
          // await createCar(data, token);
          // setFormAlert({
          //   type: "success",
          //   message: `Jūsų automobilio duomenys išsiųsti peržiūrai! Apie statusą informuosime jus el. paštu: ${auth.user.email}`,
          // });
          // reset(); // Empty the form
    setfileInputAlert(null); // Empty the alert
          // } catch(error) {
          //             console.log("error: ");
          //             console.log(error);
          //   setfileInputAlert(null); // Empty the alert
          //   setFormAlert({
          //     type: "error",
          //     message: "Deja, automobilio duomenų nusiųsti nepavyko. Atsiųskite juos mums el. paštu: ugnius@trymycar.com",
          //   });
          // }
          // // Clear the form 
          // reset(); // Empty the form
    setPending(false);
  };

  const uploadPhoto = async (e) => {
    const folder = "cars/owner-initial-uploads/";
    const file = e.target.files[0];
    if (!file) {
      setValue("carPhotoUploaded", ""); // Empty the hidden input value as well
      setfileInputAlert(null);
      return; // if the file input is empty, end the function
    }
    setPendingFileUpload(true);
    // get a pre-signed URL for uploading
    const preSignedUrl = await getUploadUrl(file, folder);
    const { url, fields } = await preSignedUrl.json();

    // upload file with the pre-signed url
    const upload = await uploadFileToPresignedUrl(file, url, fields);
    if (upload.ok) {
      console.log("Upload successful!");
      // Set the hidden input value: 
      setValue("carPhotoUploaded", process.env.NEXT_PUBLIC_AMAZON_CLOUDFRONT_ENDPOINT + fields.key);
      clearErrors("carPhotoUploaded"); // clear hidden input errors manually
      setfileInputAlert({
        type: "success",
        message: `Nuotrauka paruošta įkėlimui`,
      });
    } else {
      setfileInputAlert({
        type: "error",
        message: `Nuotraukos įkėlimas negalimas. Susisiekite su mūsų pagalba: +370 625 13762.`,
      });
    }

    setPendingFileUpload(false);
  };

  const renderFuelUsageOptions = () => {
    var rows = [];
    for (let liters = 0; liters < 25; liters++) {
      rows.push(<option key={liters} value={liters}>~{liters} litrai / 100 km</option>);
    }
    return rows;
  }

  const renderSeatOptions = () => {
    var rows = [];
    for (let seats = 2; seats < 10; seats++) {
      rows.push(<option key={seats} value={seats}>{seats} sėdimos vietos</option>);
    }
    return rows;
  }

  const renderManufacturingYearOptions = () => {
    var rows = [];
    var now_year = new Date().getFullYear();
    rows.push(<option key="2000" value="ankstesni nei 2010">ankstesni nei 2010</option>);
    for (let man_year = 2010; man_year <= now_year; man_year++) {
      rows.push(<option key={man_year} value={man_year}>{man_year}</option>);
    }
    return rows;
  }

  const renderCarMakeOptions = () => {
    var rows = [];
    carMakeArray.map((carMake) => {
      rows.push(<option key={carMake} value={carMake}>{carMake}</option>);
    })
    return rows;
  }

  const renderMileageOptions = () => {
    var rows = [];
    for (let mileage = 200; mileage < 210; mileage++) {
      rows.push(<option key={mileage} value={mileage}>{mileage} nuvažiuoti kilometrai</option>);
    }
    return rows;
  }

  return (
    <>
      <div style={{ position: "relative" }}>
        {formAlert && (
          <FormAlert type={formAlert.type} message={formAlert.message} />
        )}

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Row>
            <Form.Group
              as={Col}
              xs={12}
              sm={props.showNameField ? 6 : 12}
              controlId="formCarMark"
            >
              <Form.Label size="md">Gamintojas</Form.Label>
              <Form.Control 
                size="lg"
                name="mark"
                as="select" 
                defaultValue={get(car, 'mark', 'Toyota')}
                placeholder="Gamintojas, pvz. Toyota"
                ref={register({
                  required: "Įveskite gamintoją, pvz. Volkswagen",
                })}
                error={errors.mark}
              >
                {renderCarMakeOptions()}
              </Form.Control>
            </Form.Group>
            <Form.Group
              as={Col}
              xs={12}
              sm={props.showNameField ? 6 : 12}
              controlId="formCarModel"
            >
              <Form.Label size="md">Modelis</Form.Label>
              <FormField
                size="lg"
                name="model"
                type="text"
                placeholder="Modelis, pvz. Prius"
                error={errors.model}
                inputRef={register({
                  required: "Įveskite modelį, pvz. Golf",
                })}
                defaultValue={get(car, 'model', 'Corolla')}
              />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group
              as={Col}
              xs={12}
              sm={props.showNameField ? 6 : 12}
              controlId="formCarManufacturingYear"
            >
              <Form.Label size="md">Gamybos metai</Form.Label>
              <Form.Control 
                      size="lg"
                      name="year"
                      as="select" 
                      defaultValue={get(car, 'year', 2014)}
                      placeholder="Pagaminimo metai" 
                      ref={register}
                    >
                      {renderManufacturingYearOptions()}
                </Form.Control>
            </Form.Group>
            <Form.Group
              as={Col}
              xs={12}
              sm={props.showNameField ? 6 : 12}
              controlId="formOdometerReading"
            >
              <Form.Label size="md">Odometras / Nuvažiuotas kilometražas</Form.Label>
              <FormField
                size="lg"
                name="mileage"
                type="text"
                placeholder="Odometro rodmuo, pvz. ~140 000 km"
                error={errors.mileage}
                inputRef={register({
                  required: "Įveskite, kiek km yra nuvažiavęs automobilis",
                })}
                defaultValue={get(car, 'mileage', 140560)}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group
              as={Col}
              xs={12}
              sm={props.showNameField ? 6 : 12}
              controlId="formTransmission"
            >
              <Form.Label size="md">Greičių dėžė</Form.Label>
              <Form.Control 
                  size="lg"
                  name="transmission"
                  as="select" 
                  defaultValue={get(car, 'transmission', Server.transmission.AUT)}
                  placeholder="Pavarų dėžė" 
                  ref={register}
                >
                  {Object.keys(Server.transmission).map((key) => (
                    <option key={Server.transmission[key]} value={Server.transmission[key]}>{Dictionary.carTransmission[Server.transmission[key]][AppState.language]}</option>
                    ))}
              </Form.Control>
            </Form.Group>
            <Form.Group
              as={Col}
              xs={12}
              sm={props.showNameField ? 6 : 12}
              controlId="formAddress"
            >
              <Form.Label size="md">Automobilio stovėjimo adresas</Form.Label>
              <FormAddressField 
                inputSetValue={(field, value) => setValue(field, value)}
                inputRef={register}
                inputControl={control}
                inputRules={{ required: "Įveskite automobilio adresą" }}
                error={errors.address}
                // defaultValue={{ latituda: get(car, 'current_location.latitude'), longitude: get(car, 'current_location.longitude') }}
                defaultValue={get(car, 'address')}
                inputName="address"
              />
            </Form.Group>            
          </Form.Row>

          <Form.Row>
            <Form.Group
              as={Col}
              xs={12}
              sm={props.showNameField ? 6 : 12}
              controlId="formRegNumber"
            >
              <Form.Label size="md">Registracijos numeris</Form.Label>
              <FormField
                size="lg"
                name="reg_number"
                type="text"
                placeholder="Reg. numeris, pvz. ABC 311"
                error={errors.reg_number}
                inputRef={register({
                  required: "Įveskite automobilio registracijos numerį",
                })}
                defaultValue={get(car, 'reg_number', 'ABC 123')}
              />
            </Form.Group>
            <Form.Group
              as={Col}
              xs={12}
              sm={props.showNameField ? 6 : 12}
              controlId="formFuelConsumption"
            >
              <Form.Label size="md">Kuro suvartojimas</Form.Label>
              <Form.Control 
                      size="lg"
                      name="fuel_consumption"
                      as="select" 
                      defaultValue={get(car, 'fuel_consumption', 7)}
                      placeholder="Suvartojamo kurio kiekis (litrais)" 
                      ref={register}
                    >
                      {renderFuelUsageOptions()}
                </Form.Control>
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group
              as={Col}
              xs={12}
              sm={props.showNameField ? 6 : 12}
              controlId="formSeats"
            >
              <Form.Label size="md">Sėdimos vietos</Form.Label>
              <Form.Control 
                    size="lg"
                    name="seats"
                    as="select" 
                    defaultValue={get(car, 'seats', 5)}
                    placeholder="Sėdimų vietų skaičius, pvz. 5" 
                    ref={register}
                  >
                    {renderSeatOptions()}
              </Form.Control>
            </Form.Group>
            <Form.Group
              as={Col}
              xs={12}
              sm={props.showNameField ? 6 : 12}
              controlId="formCarType"
            >
              <Form.Label size="md">Kėbulo tipas</Form.Label>
              <Form.Control 
                      size="lg"
                      name="car_type"
                      as="select" 
                      defaultValue={get(car, 'car_type', Server.carType.HATCHBACK)}
                      placeholder="Automobilio tipas" 
                      ref={register}
                    >
                      {Object.keys(Server.carType).map((key) => (
                        <option key={Server.carType[key]} value={Server.carType[key]}>{Dictionary.carType[Server.carType[key]][AppState.language]}</option>
                      ))}
                </Form.Control>
            </Form.Group>
          </Form.Row>

          <Form.Row>
          <Form.Group
              as={Col}
              xs={12}
              sm={props.showNameField ? 6 : 12}
              controlId="formFuelType"
            >
              <Form.Label size="md">Kuro tipas</Form.Label>
              <Form.Control 
                size="lg"
                name="fuel"
                as="select" 
                defaultValue={get(car, 'fuel', Server.fuel.DIESEL)}
                placeholder="Kuro tipas" 
                ref={register}
              >
                {Object.keys(Server.fuel).map((key) => (
                    <option key={Server.fuel[key]} value={Server.fuel[key]}>{Dictionary.fuel[Server.fuel[key]][AppState.language]}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form.Row>

          {/* <Form.Row>
            <Form.Group
              as={Col}
              xs={12}
              sm={props.showNameField ? 6 : 12}
              controlId="formPhoto"
            >
              <Form.File
                id="carphoto"
                name="carphoto"
                label="Įkelkite automobilio nuotrauką"
                accept="image/png, image/jpeg"
                onChange={uploadPhoto}
              />
              <Form.Control
                type="hidden"
                ref={register({ required: "Neįkėlėte automobilio nuotraukos." })}
                name="carPhotoUploaded"
                isInvalid={errors.carPhotoUploaded ? true : undefined}
              />
              {errors.carPhotoUploaded && (
              <Form.Control.Feedback type="invalid" className="text-left" style={{ display: "block"}}>
                {errors.carPhotoUploaded.message}
              </Form.Control.Feedback>)}

              {pendingFileUpload && (
                <>
                  <Spinner
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden={true}
                    className="ml-2"
                  ></Spinner>
                  <span>&nbsp;Tikrinama nuotrauka...</span>
                </>
              )}
              {fileInputAlert && (
                <FormAlert
                  type={fileInputAlert.type}
                  message={fileInputAlert.message}
                />
              )}
            </Form.Group>
          </Form.Row> */}

          <Button
            variant={props.buttonColor}
            size="lg"
            type="submit"
            disabled={pending}
          >
            <span>{props.buttonText}</span>

            {pending && (
              <Spinner
                animation="border"
                size="sm"
                role="status"
                aria-hidden={true}
                className="ml-2"
              >
                <span className="sr-only">Sending...</span>
              </Spinner>
            )}
          </Button>
        </Form>
        {/* {fileInputAlert && (
        <Toast 
          style={{ 
            position: "absolute",
            bottom: "0",
            right: "50%"
           }}
          onClose={() => setfileInputAlert(false)} show={fileInputAlert} delay={15000} autohide
          >
          <Toast.Header>
            <svg class=" rounded mr-2" width="20" height="20" xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid slice" focusable="false" role="img">
                    <rect fill="#007aff" width="100%" height="100%" />
            </svg>
            <strong className="mr-auto">Bootstrap</strong>
            <small>11 mins ago</small>
          </Toast.Header>
          <Toast.Body>Woohoo, nuotrauka tinka! Tęskime...</Toast.Body>
        </Toast>
      )} */}
      </div>
    </>
  );
}

export default GoogleApiWrapper({
  apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
})(AddCarForm);

// var current_user = auth.user;
// const upload = await uploadDirectlyFromFrontend(data, current_user);
// if (upload.ok) {
//   reset();
//   setFormAlert({
//     type: "success",
//     message: `Jūsų automobilio duomenys išsiųsti peržiūrai! Apie statusą informuosime jus el. paštu: ${auth.user.email}`,
//   });
// } else {
//   setFormAlert({
//     type: "error",
//     message: upload.error + ": " + upload.errorMsg,
//   });
// }